import classNames from 'classnames/bind';
import styles from './SignUp.module.scss';
import { AppBar, Box, Link, TextField, Typography } from '@mui/material';
import { images } from '~/assets';
import { Button } from '@mui/material';
import { styled } from '@mui/system';
import { adminRouteAbsolute } from '~/utils/constants/route';
import { useNavigate } from 'react-router-dom';

const cx = classNames.bind(styles);

type Props = {};

const CustomTextField = styled(TextField)({
  '& .MuiOutlinedInput-root': {
    borderRadius: '8px',
    height: '36px',
    paddingLeft: '15px',
    paddingRight: '15px',
  },
  '& .MuiOutlinedInput-notchedOutline': {
    borderColor: '#D2DAE1',
  },
  '& .MuiInputBase-input': {
    padding: '2.5px 0',
  },
});

const SignUp = (_props: Props) => {
  const navigate = useNavigate();

  const redirectSignUp = () => {
    navigate(`${adminRouteAbsolute.signUp}`);
  };

  const redirectLogin = () => {
    navigate(`${adminRouteAbsolute.login}`);
  };

  const handleSignUp = () => {
    navigate(`${adminRouteAbsolute.dashboard}`);
  };

  return (
    <Box className={cx('w-full', 'h-full')}>
      <AppBar
        color='inherit'
        className={cx('px-4 md:px-20 py-2.5 border-b border-[#E5EAEF]')}
        elevation={0}
        position='relative'
      >
        <Box className={cx('flex justify-between items-center')}>
          <img src={images.logo} alt='' className={cx('w-[61px] h-[62px]')} />
          <Box className={cx('h-9')}>
            <Button
              className={cx(
                'h-9 w-16 inline-block !font-medium !rounded-lg !leading-[16.8px] !text-[#3A3F51] !mr-3 !px-[14px] !py-[7px]'
              )}
              onClick={redirectLogin}
            >
              Login
            </Button>
            <Button
              variant='contained'
              color='primary'
              className={cx('!rounded-lg !leading-[16.8px] h-9 w-[76px] !px-[14px] !py-[7px]')}
              onClick={redirectSignUp}
            >
              Sign up
            </Button>
          </Box>
        </Box>
      </AppBar>
      <Box className={cx('w-full sm:h-[calc(100%-83px)] relative z-10')}>
        <Box component='section' className={cx('w-full h-full flex justify-center items-center')}>
          <form className={cx('max-w-[500px] w-full px-4 sm:px-0')}>
            <Box>
              <Box className={cx('text-center gap-5')}>
                <img src={images.logo} alt='' className={cx('w-[60px] h-[60px] inline-block')} />
                <Box className={cx('mt-5')}>
                  <Typography className={cx('!font-medium !text-black text-[36px] !leading-[43.2px]')} variant='h2'>
                    Create an account
                  </Typography>
                  <Typography
                    variant='body1'
                    className={cx('!font-normal text-[16px] !leading-[19.2px] !text-[#86929D] !mt-2.5')}
                  >
                    Enter your email and password to create an account
                  </Typography>
                </Box>
              </Box>
              <Box className={cx('sm:mt-[60px] mt-6')}>
                <Box>
                  <Typography
                    className={cx('!block text-[12px] text-[#323953] !font-normal !leading-[14.4px] !mb-1.5 =')}
                  >
                    Name
                  </Typography>
                  <CustomTextField variant='outlined' placeholder='Name' fullWidth />
                </Box>
                <Box className={cx('mt-5')}>
                  <Typography
                    className={cx('!block text-[12px] text-[#323953] !font-normal !leading-[14.4px] !mb-1.5')}
                  >
                    Email
                  </Typography>
                  <CustomTextField variant='outlined' placeholder='Enter your email' fullWidth />
                </Box>
                <Box className={cx('mt-5')}>
                  <Typography
                    className={cx('!block text-[12px] text-[#323953] !font-normal !leading-[14.4px] !mb-1.5')}
                  >
                    Password
                  </Typography>
                  <CustomTextField
                    variant='outlined'
                    type='password'
                    placeholder='Password'
                    fullWidth
                    autoComplete=''
                  />
                </Box>
                <Typography className={cx('!font-normal !leading-[16.8px] !text-[#86929D] !mt-3')}>
                  Must be at least 8 characters
                </Typography>
              </Box>
            </Box>
            <Box className={cx('mt-[30px]')}>
              <Button
                variant='contained'
                color='primary'
                sx={{
                  boxShadow: 'none',
                  '&:hover': {
                    boxShadow: 'none',
                  },
                }}
                className={'w-full !rounded-lg h-9 !leading-[16.8px]'}
                onClick={handleSignUp}
              >
                Create account
              </Button>
              <p className={'text-center text-base mt-5 text-[16px]'}>
                <span className={'text-[#86929D] font-normal'}>Already have an account? </span>
                <Link href='#' underline='none' className={'!font-medium'}>
                  Sign in
                </Link>
              </p>
            </Box>
          </form>
        </Box>
      </Box>
      <Box
        className={cx(
          'w-full',
          'h-[40%]',
          'background-bottom',
          'fixed',
          'bottom-0',
          'bg-cover',
          'bg-center',
          'opacity-[0.02]'
        )}
      ></Box>
    </Box>
  );
};

export default SignUp;
